import { render } from "./LessonsManagement.vue?vue&type=template&id=34753c67&scoped=true"
import script from "./LessonsManagement.vue?vue&type=script&lang=js"
export * from "./LessonsManagement.vue?vue&type=script&lang=js"

import "./LessonsManagement.vue?vue&type=style&index=0&id=34753c67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34753c67"]])

export default __exports__